// src/components/Login.jsx
import { useMediaQuery } from "@mui/material";
import LoginDesktop from "./LoginDesktop";
import LoginMobile from "./LoginMobile";

export default function Login() {
  // true si écran large
  const isDesktop = useMediaQuery("(min-width:768px)");
  return isDesktop ? <LoginDesktop /> : <LoginMobile />;
}
